<template>
  <div class="audio-record">
    <!-- <div
      v-if="!isRecording"
      class="audio-record__pending"
      @click="initRec"
    >
      开始会议录音
    </div> -->
    <div class="audio-record__underway">
      <div v-if="isMedicalIndustry !== 1 || isShowRecordDuration" class="animation">
        <div ref="waveRef" class="waveRef"></div>
      </div>
      <div v-if="isRecording" class="record">
        <div v-if="!isMobile()" class="record__time" style="margin-bottom: 0.75rem">
          <span v-if="isMedicalIndustry === 1 && !isShowRecordDuration" class="medical">
            {{ recordStatusText }}
          </span>
          <span v-else> {{ isPause ? '已暂停' : ` ${recordTime}` }}</span>
        </div>
        <div
          v-else-if="(isMobile() && isMedicalIndustry !== 1) || isShowRecordDuration"
          class="record__time"
          style="margin-bottom: 0.75rem"
        >
          <span> {{ isPause ? '已暂停' : ` ${recordTime}` }}</span>
        </div>
        <div class="record__btns">
          <div
            class="pause-icon record__btn"
            style="margin-right: 1rem"
            :style="{ width: medicalIndustryBtn.width }"
            @click="pauseRecording"
          >
            <span
              v-if="isMedicalIndustry === 1 && !isShowRecordDuration"
              :style="{ color: medicalIndustryBtn.cancelColor }"
              >{{ cancelBtnText }}</span
            >
            <i v-else class="t-iconfont" :class="isPause ? 'icon-mic-line' : 'icon-pause-line'"></i>
          </div>
          <div
            class="finish-icon record__btn"
            :style="{ width: medicalIndustryBtn.width }"
            @click="stopRecording"
          >
            <span
              v-if="isMedicalIndustry === 1 && !isShowRecordDuration"
              :style="{ color: medicalIndustryBtn.confirmColor }"
              >完成拜访</span
            >
            <i v-else class="icon-check-line t-iconfont"></i>
          </div>
        </div>
        <div class="record__cancel" @click="confirmCancelDialogVisible = true">取消</div>
      </div>
    </div>
    <el-dialog
      v-model="confirmCancelDialogVisible"
      append-to-body
      :class="isMobile() ? 'mobile-common-dialog' : 'web-common-dialog'"
      :show-close="!isMobile()"
      title="取消"
      top="40vh"
      :width="isMobile() ? '80%' : '400'"
    >
      <span>确定后将不会保存，确定取消吗</span>
      <template #footer>
        <template v-if="isMobile()">
          <div class="btn" @click="confirmCancelDialogVisible = false">取消</div>
          <div class="btn" @click="cancelRecord">确定</div>
        </template>
        <div v-else class="dialog-footer">
          <el-button @click="confirmCancelDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="cancelRecord"> 确定 </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, computed, ref, nextTick, watch } from 'vue'
import { clearStart, endAsr } from '@/api/chat'
import Recorder from 'recorder-core'
import utils from '@/utils'
import { ElMessage } from 'element-plus'
//引入mp3格式支持文件；如果需要多个格式支持，把这些格式的编码引擎js文件放到后面统统引入进来即可
import 'recorder-core/src/engine/mp3'
import 'recorder-core/src/engine/mp3-engine'
//录制wav格式的用这一句就行
//import 'recorder-core/src/engine/wav'

//可选的插件支持项，这个是波形可视化插件
import 'recorder-core/src/extensions/waveview'
import { useOSS } from '@/utils/oss'
import h5Api from '../utils/h5/h5-others'
import { isMobile } from '@/utils'
import xbb from '@xbb/xbb-utils'

const emits = defineEmits('start-record', 'stop-record', 'start-asr', 'asr-data', 'pause-status')

const props = defineProps({
  // 是否医疗行业特殊样式（0-否，1-是）
  isMedicalIndustry: {
    type: Number,
    default: 0
  },
  // 医疗行业下，是否允许显示录音时长（0-否，1-是）
  isShowRecordDuration: {
    type: Number,
    default: 0
  },
  openAsr: {
    type: Boolean,
    default: false
  }
})

const { appendUpload, generateFileName, deleteFile } = useOSS()

const isRecording = ref(false)
const recordTime = ref('00:00:00')

const rec = ref(null)
const waveRef = ref(null)
const wave = ref(null)

const isPause = ref(false)
const recordedTime = ref(0)
let recordingWakelockHeld = false

const confirmCancelDialogVisible = ref(false)

function setRecordingWakelock(enabled) {
  if (!window.plus) return
  if (enabled && recordingWakelockHeld) return

  try {
    window.plus.device.setWakelock(enabled)
    recordingWakelockHeld = enabled
  } catch (error) {
    console.error(`${enabled ? '开启' : '释放'}录音屏幕常亮失败：`, error)
  }
}

function releaseRecordingWakelock() {
  // 即使本地状态已经丢失，也执行关闭，确保退出录音时不会遗留常亮状态。
  setRecordingWakelock(false)
  recordingWakelockHeld = false
}

// 追加上传相关状态
const uploadFileName = ref('') // 当前上传的临时文件名
const appendPosition = ref(0) // 当前追加位置
const chunkBuffer = ref([]) // 小块数据缓冲区
const bufferSize = ref(0) // 缓冲区大小
const uploadQueue = ref([]) // 待上传的合并后数据队列
const isUploading = ref(false) // 是否正在上传
const fileExists = ref(false) // 标记文件是否已在OSS上存在
const MAX_BUFFER_SIZE = 32 * 1024 // 32KB缓冲区阈值
const MAX_RETRY = 3 // 最大重试次数

// 医疗行业按钮样式
const medicalIndustryBtn = computed(() => {
  if (props.isMedicalIndustry === 1) {
    return {
      width: isMobile() ? '50%' : '85px',
      cancelColor: '#323233',
      confirmColor: '#FFFFFF'
    }
  } else {
    return {
      width: '',
      cancelColor: '',
      confirmColor: ''
    }
  }
})
// 取消按钮文字
const cancelBtnText = computed(() => {
  if (isPause.value) {
    return '继续拜访'
  } else {
    return '暂停拜访'
  }
})
// 录音状态文字
const recordStatusText = computed(() => {
  if (isPause.value) {
    return '暂停拜访中'
  } else {
    return '拜访中...'
  }
})

onMounted(async () => {
  if (window.plus) {
    h5Api.h5ChoosePermission({ type: 4, onSuccess: initRec })
  } else {
    initRec()
  }
})

onBeforeUnmount(() => {
  console.log('---组件销毁---结束录音')

  isRecording.value = false
  releaseRecordingWakelock()
  rec.value && rec.value.close()
  console.log('---组件销毁---结束录音')

  rec.value = null
  emits('stop-record')
})

/**
 * @description 带重试的追加上传
 */
const uploadWithRetry = async (queueItem) => {
  const { bytes, chunkCount } = queueItem
  const blob = new Blob([bytes.buffer], { type: 'audio/mp3' })
  const bytesLength = bytes.length

  for (let i = 0; i <= MAX_RETRY; i++) {
    try {
      const currentPosition = appendPosition.value

      console.log(
        `[上传] 第${i + 1}次尝试，位置=${currentPosition}, 大小=${bytesLength}, chunks数=${chunkCount}`
      )

      const result = await appendUpload(
        uploadFileName.value,
        blob,
        currentPosition,
        fileExists.value
      )
      const expectedPosition = currentPosition + bytesLength

      // 第一次成功上传后，标记文件已存在
      if (!fileExists.value) {
        fileExists.value = true
      }

      // 验证位置是否正确
      if (result.nextAppendPosition === expectedPosition) {
        appendPosition.value = result.nextAppendPosition
        console.log(`[上传] 成功，位置=${appendPosition.value}`)
        return true
      } else {
        // 位置不匹配，更新位置并记录警告
        console.warn(`[上传] 位置异常: 预期=${expectedPosition}, 实际=${result.nextAppendPosition}`)
        appendPosition.value = result.nextAppendPosition
        return true
      }
    } catch (err) {
      // 检查是否是位置不匹配错误
      if (err instanceof Error && err.message.includes('Position mismatch')) {
        // 从错误消息中提取实际位置
        const match = err.message.match(/actual=(\d+)/)
        if (match) {
          const actualPosition = Number(match[1])
          console.warn(`[上传] 位置不匹配，同步位置: ${appendPosition.value} -> ${actualPosition}`)
          appendPosition.value = actualPosition
          // 位置不匹配时，立即重试而不等待
          continue
        }
      }

      console.error(`[上传] 失败，第${i + 1}/${MAX_RETRY + 1}次:`, err)

      if (i === MAX_RETRY) {
        console.error(`[上传] 超过最大重试次数`)
        return false
      }

      // 等待后重试（递增等待时间）
      await new Promise((resolve) => setTimeout(resolve, 500 * (i + 1)))
    }
  }
  return false
}

/**
 * @description 处理上传队列
 */
const processUploadQueue = async () => {
  if (isUploading.value || uploadQueue.value.length === 0) {
    return
  }

  isUploading.value = true

  try {
    while (uploadQueue.value.length > 0) {
      const queueItem = uploadQueue.value.shift()
      const success = await uploadWithRetry(queueItem)

      if (!success) {
        console.error('[队列] 上传失败，跳过该chunk')
        // 可以选择重新加入队列或丢弃
      }
    }
  } finally {
    isUploading.value = false
  }
}

function startForegroundService() {
  if (xbb.browser() === 'ios') return
  try {
    console.log('保活开始')
    const main = window.plus.android.runtimeMainActivity()
    const Intent = window.plus.android.importClass('android.content.Intent')
    const ComponentName = window.plus.android.importClass('android.content.ComponentName')
    console.log('保活开始1')
    const intent = new Intent()
    const cmp = new ComponentName(
      'com.xbongbong.crm.chatbot.ai', // 包名
      'com.xbongbong.service.BackgroundRecordingService' // 服务全名
    )
    intent.setComponent(cmp)
    console.log('保活开始2')
    // Android 8+ 需要使用 startForegroundService
    if (window.plus.os.name === 'Android') {
      const Build = window.plus.android.importClass('android.os.Build')
      const activity = main
      if (Build.VERSION.SDK_INT >= 26) {
        console.log('保活开始3')
        activity.startForegroundService(intent)
      } else {
        console.log('保活开始4')
        activity.startService(intent)
      }
    }
  } catch (error) {
    console.log('保活错误：', error)
  }
}

/**
 * 初始化录音
 */
function initRec() {
  let clearBufferIdx = 0
  const recorderConfig = {
    type: 'mp3', //录音格式，可以换成wav等其他格式
    sampleRate: 16000, //录音的采样率，越大细节越丰富越细腻
    bitRate: 16, //录音的比特率，越大音质越好
    onProcess: (buffers, powerLevel, bufferDuration, bufferSampleRate, newBufferIdx, asyncEnd) => {
      //录音实时回调，大约1秒调用12次本回调
      //可实时绘制波形，实时上传（发送）数据
      recordedTime.value = Math.floor(bufferDuration / 1000)
      recordTime.value = formatRecordTime(recordedTime.value)
      if (wave.value) wave.value.input(buffers[buffers.length - 1], powerLevel, bufferSampleRate)

      // https://xiangyuecn.github.io/Recorder/assets/%E5%B7%A5%E5%85%B7-%E4%BB%A3%E7%A0%81%E8%BF%90%E8%A1%8C%E5%92%8C%E9%9D%99%E6%80%81%E5%88%86%E5%8F%91Runtime.html?jsname=teach.realtime.encode_transfer_mp3
      for (let i = clearBufferIdx; i < newBufferIdx; i++) {
        buffers[i] = null
      }
      clearBufferIdx = newBufferIdx
    },
    takeoffEncodeChunk: (chunkBytes) => {
      // 【Recorder内置实时转码方法】实时接收编码器编码出来的音频片段数据
      if (chunkBytes && chunkBytes.length > 0) {
        // 将小块加入缓冲区
        chunkBuffer.value.push(chunkBytes)
        bufferSize.value += chunkBytes.length

        // 满足条件时合并上传：
        // 1. 缓冲区达到阈值
        // 2. 队列为空且不在上传中（避免积压）
        const shouldUpload =
          bufferSize.value >= MAX_BUFFER_SIZE ||
          (uploadQueue.value.length === 0 && !isUploading.value && bufferSize.value > 8192)

        if (shouldUpload && chunkBuffer.value.length > 0) {
          // 直接使用已维护的bufferSize，避免重复计算
          const mergedBytes = new Uint8Array(bufferSize.value)
          let offset = 0

          for (const chunk of chunkBuffer.value) {
            mergedBytes.set(chunk, offset)
            offset += chunk.length
          }

          const chunkCount = chunkBuffer.value.length

          // 将合并后的数据加入上传队列
          uploadQueue.value.push({
            bytes: mergedBytes,
            chunkCount: chunkCount,
            retryCount: 0
          })

          // 清空缓冲区
          chunkBuffer.value = []
          bufferSize.value = 0

          // 如果当前没有正在上传，触发上传
          if (!isUploading.value) {
            processUploadQueue()
          }
        }

        // 如果需要ASR，继续发送ASR数据
        if (props.openAsr) {
          RealTimeSendTry(chunkBytes, false)
        }
      }
    }
  }
  rec.value = Recorder(recorderConfig)
  console.log('录音对象初始化rec.value = ', rec.value)

  rec.value.open(
    async () => {
      // 正常录音初始化
      if (props.openAsr) {
        clearStart()
          .then((res) => {
            console.log('clearStart', res)
            if (res.result.id) {
              utils.xbbLocalStorageSet('asr_id', res.result.id)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
      console.log('录音已打开')
      await paramsInit() // 初始化上传参数
      emits('start-record')
      emits('start-asr', rec.value)

      startRecording()

      nextTick(() => {
        if (waveRef.value) {
          //创建音频可视化图形绘制对象
          wave.value = Recorder.WaveView({ elem: waveRef.value })
        }
      })
    },
    (msg, isUserNotAllow) => {
      //用户拒绝了录音权限，或者浏览器不支持录音
      ElMessage.error('麦克风权限未开启')
      isRecording.value = false
      releaseRecordingWakelock()
      emits('stop-record')
      console.log((isUserNotAllow ? 'UserNotAllow，' : '') + '无法录音:' + msg)
    }
  )
}

function startRecording() {
  if (!rec.value) {
    releaseRecordingWakelock()
    return
  }

  if (window.plus) {
    setRecordingWakelock(true)
    h5Api.h5ChoosePermission({
      type: 10,
      onSuccess: startForegroundService,
      onFail: releaseRecordingWakelock
    })
  }
  isRecording.value = true
  isPause.value = false
  try {
    rec.value.start()
  } catch (error) {
    isRecording.value = false
    releaseRecordingWakelock()
    throw error
  }
  console.log('已开始录音')
}

function formatRecordTime(seconds) {
  const hours = Math.floor(seconds / 3600)
    .toString()
    .padStart(2, '0')
  const minutes = Math.floor((seconds % 3600) / 60)
    .toString()
    .padStart(2, '0')
  const secs = Math.floor(seconds % 60)
    .toString()
    .padStart(2, '0')
  return `${hours}:${minutes}:${secs}`
}

function pauseRecording() {
  console.log('暂停/继续录音rec.value = ', rec.value)

  isPause.value = !isPause.value
  if (isPause.value) {
    rec.value.pause()
  } else {
    rec.value.resume()
  }
}

// 结束录音辅助方法
const stopRecord = async () => {
  console.log('props.openAsr = ', props.openAsr)

  // 1. 处理缓冲区中剩余的数据
  if (chunkBuffer.value.length > 0) {
    console.log('[停止] 处理缓冲区剩余数据')
    const mergedBytes = new Uint8Array(bufferSize.value)
    let offset = 0

    for (const chunk of chunkBuffer.value) {
      mergedBytes.set(chunk, offset)
      offset += chunk.length
    }

    uploadQueue.value.push({
      bytes: mergedBytes,
      chunkCount: chunkBuffer.value.length,
      retryCount: 0
    })

    chunkBuffer.value = []
    bufferSize.value = 0
  }

  // 2. 上传队列中剩余的数据
  if (uploadQueue.value.length > 0) {
    console.log('[停止] 处理上传队列')
    await processUploadQueue()
  }

  // 3. 等待正在进行的上传完成
  while (isUploading.value) {
    await new Promise((resolve) => setTimeout(resolve, 100))
  }

  // 4. 直接发送临时文件名，重命名操作由父组件完成
  if (uploadFileName.value && appendPosition.value > 0) {
    console.log('[停止] 发送临时文件名:', uploadFileName.value)
    emits('stop-record', uploadFileName.value, appendPosition.value)
  } else {
    console.log('[停止] 没有上传任何数据，录音可能为空')
    emits('stop-record', null)
  }

  // 5. 处理ASR结束
  if (props.openAsr) {
    // 发送ASR缓冲区中剩余的数据
    if (send_frameBuffer && send_frameBuffer.length > 0) {
      console.log('[停止] 发送ASR缓冲区剩余数据，大小:', send_frameBuffer.length)
      RealTimeSendTry(new Uint8Array(0), true) // 传入空数据，但设置isClose=true来处理剩余缓冲区
    }

    console.log('准备开始结束实时转录')

    endAsr({ id: +utils.xbbLocalStorageGet('asr_id') })
      .then((res) => {
        console.log('结束实时转录', res)
        utils.xbbLocalStorageRemove('asr_id')
      })
      .catch((err) => {
        console.log('结束实时转录失败', err)
      })
  }
}

async function stopRecording() {
  console.log('---结束录音---')
  console.log('rec.value = ', rec.value)

  if (!rec.value) {
    releaseRecordingWakelock()
    return
  }

  isRecording.value = false
  releaseRecordingWakelock()

  // 执行停止录音流程
  console.log('执行正常的停止录音流程')

  rec.value.stop(
    async (blob) => {
      try {
        await stopRecord()
      } finally {
        releaseRecordingWakelock()
        rec.value?.close()
        rec.value = null
        console.log('结束录音')
      }
    },
    (err) => {
      console.error('结束录音出错：' + err)
      releaseRecordingWakelock()
      rec.value?.close()
      rec.value = null
    }
  )
}

async function cancelRecord() {
  console.log('---取消录音---')
  console.log('rec.value = ', rec.value)
  releaseRecordingWakelock()

  // 1. 清除缓冲区和队列
  chunkBuffer.value = []
  bufferSize.value = 0
  uploadQueue.value = []

  // 2. 删除已上传的临时文件
  if (uploadFileName.value && appendPosition.value > 0) {
    try {
      await deleteFile(uploadFileName.value)
      console.log('[取消] 已删除临时录音文件')
    } catch (err) {
      console.error('[取消] 删除临时文件失败:', err)
    }
  }

  // 3. 重置状态
  uploadFileName.value = ''
  appendPosition.value = 0
  confirmCancelDialogVisible.value = false
  isRecording.value = false

  // 只有录音对象存在时才关闭
  if (rec.value) {
    rec.value.close()
    rec.value = null
  }

  emits('stop-record')

  // 4. 结束ASR
  if (props.openAsr) {
    // 清空ASR缓冲区（取消录音时不需要发送剩余数据）
    if (send_frameBuffer) {
      send_frameBuffer = new Uint8Array(0)
    }

    endAsr({ id: +utils.xbbLocalStorageGet('asr_id') })
      .then((res) => {
        console.log('结束实时转录', res)
        utils.xbbLocalStorageRemove('asr_id')
      })
      .catch((err) => {
        console.log('结束实时转录失败', err)
      })
  }
}

/** 录音处理，用于ASR start*/
let SendFrameSize = 20480
let send_frameBuffer
let send_logNumber = 0

const paramsInit = async () => {
  // 生成临时文件名
  uploadFileName.value = await generateFileName({
    file: 'init.mp3',
    isBackup: true
  })

  // 重置上传相关状态
  appendPosition.value = 0
  chunkBuffer.value = []
  bufferSize.value = 0
  uploadQueue.value = []
  isUploading.value = false
  fileExists.value = false // 新文件，标记为不存在

  // ASR相关初始化
  if (props.openAsr) {
    SendFrameSize = 20480
    send_frameBuffer = new Uint8Array(0)
    send_logNumber = 0
  }
}

const testLogFrame = async (frameBytes, number) => {
  const recSet = rec.value.set
  const blob = new Blob([frameBytes.buffer], {
    type: 'audio/' + recSet.type
  })
  // 使用 slice 方法替代已弃用的 substr 方法
  const logMsg = 'No.' + (number < 100 ? ('000' + number).slice(-3) : number)
  const file = new File([blob], `${logMsg}.mp3`, {
    type: blob.type // 保留原始 Blob 的 MIME 类型
  })
  // ASR 实时传输数据
  emits('asr-data', file, number)
}

const TransferUpload = (frameBytes, isClose) => {
  if (frameBytes.length > 0) {
    const number = ++send_logNumber
    testLogFrame(frameBytes, number)
  }
}

const RealTimeSendTry = (chunkBytes, isClose) => {
  if (!SendFrameSize) {
    TransferUpload(chunkBytes, isClose)
    return
  }
  //先将数据写入缓冲，再按固定大小切分后发送
  let frameBuffer = send_frameBuffer
  const tmp = new Uint8Array(frameBuffer.length + chunkBytes.length)
  tmp.set(frameBuffer, 0)
  tmp.set(chunkBytes, frameBuffer.length)
  frameBuffer = tmp
  // eslint-disable-next-line no-constant-condition
  while (true) {
    // 切分出固定长度的一帧数据
    if (frameBuffer.length >= SendFrameSize) {
      const frame = new Uint8Array(frameBuffer.subarray(0, SendFrameSize))
      frameBuffer = new Uint8Array(frameBuffer.subarray(SendFrameSize))
      let closeVal = false
      if (isClose && frameBuffer.length === 0) {
        closeVal = true
      }
      TransferUpload(frame, closeVal)
      if (!closeVal) continue
    } else if (isClose) {
      const frame = frameBuffer
      frameBuffer = new Uint8Array(0)
      TransferUpload(frame, true)
      break
    }
    break
  }
  send_frameBuffer = frameBuffer
}
/** 录音处理，用于ASR end*/

// 监听isPause的变化，将其状态值传给父组件
watch(isPause, (newVal) => {
  emits('pause-status', newVal)
})

defineExpose({ cancelRecord })
</script>

<style lang="less" scoped>
.audio-record {
  &__pending {
    font-size: 16px;
    color: #fff;
    border-radius: 12px;
    background: linear-gradient(278deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
  }
  &__underway {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .animation {
      width: 278px;
      margin: auto;
      .waveRef {
        height: 50px;
        width: 278px;
      }
    }

    .record {
      width: 100%;
      color: #969799;
      font-size: 14px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .record__btns {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
      }
      &__time {
        color: #323233;
      }
      &__btn {
        cursor: pointer;
        width: 48px;
        height: 48px;
        border-radius: 64px;
        background-color: #fff;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
        .icon-check-line {
          color: #fff;
          font-size: 24px;
        }
        .icon-pause-line,
        .icon-mic-line {
          background: linear-gradient(345deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          font-size: 24px;
        }
      }
      &__cancel {
        cursor: pointer;
        margin-top: 12px;
        font-size: 14px;
        color: #969799;
      }
      .finish-icon {
        background: linear-gradient(315deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
      }
    }
  }
}
</style>
